import { addDays, format, isWeekend, startOfDay } from "date-fns";
import { nationalHolidayCsv } from "@/utils/utils";

/** この時刻（時）までの依頼をその日の受付とする（価格表「15時までの受注が当日受付扱い」） */
export const RECEPTION_CUTOFF_HOUR = 15;

const holidayKeys = new Set(
  nationalHolidayCsv
    .split("\n")
    .filter((line) => line.trim() !== "")
    .map((line) => format(new Date(line.split(",")[0]), "yyyy-MM-dd"))
);

// 年末年始（12/29〜1/3）は休業日
const isYearEndHoliday = (date: Date): boolean => {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return (month === 12 && day >= 29) || (month === 1 && day <= 3);
};

export const isBusinessDay = (date: Date): boolean =>
  !isWeekend(date) &&
  !holidayKeys.has(format(date, "yyyy-MM-dd")) &&
  !isYearEndHoliday(date);

/** 指定日の翌日以降で最初の営業日 */
export const nextBusinessDay = (date: Date): Date => {
  let next = addDays(startOfDay(date), 1);
  while (!isBusinessDay(next)) next = addDays(next, 1);
  return next;
};

/** 受付日の翌営業日を1日目として数え、days 営業日目の日を返す（受付翌日起算） */
export const addBusinessDays = (receptionDate: Date, days: number): Date => {
  let date = startOfDay(receptionDate);
  for (let count = 0; count < days; count += 1) date = nextBusinessDay(date);
  return date;
};

/** 受付日の翌日から指定日までの営業日数（指定日が受付日以前なら0） */
export const countBusinessDays = (receptionDate: Date, until: Date): number => {
  const end = startOfDay(until);
  let count = 0;
  for (
    let date = nextBusinessDay(receptionDate);
    date <= end;
    date = nextBusinessDay(date)
  ) {
    count += 1;
  }
  return count;
};

/** 依頼した時刻の受付日。営業日の15時までならその日、それ以外は次の営業日 */
export const getReceptionDate = (requestedAt: Date): Date =>
  isBusinessDay(requestedAt) && requestedAt.getHours() < RECEPTION_CUTOFF_HOUR
    ? startOfDay(requestedAt)
    : nextBusinessDay(requestedAt);
